module.exports = __webpack_public_path__ + "img/marketing-enginees.fd57d479.svg";